"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WheelTypeByPrediction = exports.WheelType = void 0;
/**
 * The four wheels of a car.s
 *
 * *Swagger Schema Reference :* `WheelType`
 */
var WheelType;
(function (WheelType) {
    /**
     * The front left wheel.
     */
    WheelType["WHEEL_FRONT_LEFT"] = "wheel_front_left";
    /**
     * The front right wheel.
     */
    WheelType["WHEEL_FRONT_RIGHT"] = "wheel_front_right";
    /**
     * The back left wheel.
     */
    WheelType["WHEEL_BACK_LEFT"] = "wheel_back_left";
    /**
     * The front right wheel.
     */
    WheelType["WHEEL_BACK_RIGHT"] = "wheel_back_right";
})(WheelType = exports.WheelType || (exports.WheelType = {}));
exports.WheelTypeByPrediction = {
    front_left: WheelType.WHEEL_FRONT_LEFT,
    front_right: WheelType.WHEEL_FRONT_RIGHT,
    back_left: WheelType.WHEEL_BACK_LEFT,
    back_right: WheelType.WHEEL_BACK_RIGHT,
};
//# sourceMappingURL=entityTypes.js.map